import { Injectable } from '@angular/core';
import { gql, Mutation } from 'apollo-angular';

import { Mutation as RootMutation } from 'graphql/models/generated';

export const UPDATE_ORGANIZATION_MUTATION = gql`
  mutation updateOrganization($id: String, $data: OrganizationUpdateInput!) {
    updateOrganization(where: { id: $id }, data: $data) {
      name
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class UpdateOrganizationMutation extends Mutation<RootMutation> {
  document = UPDATE_ORGANIZATION_MUTATION;
}
